import React from 'react';

import { Modal } from './Modal';
import { Grid2 } from '@mui/material';

export const FuelModal = ({ isOpen, handleClose, coldSoak, adjustments }) => {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <Grid2 container>
        <div style={{ width: 'fit-content' }}>
          <pre style={{ marginBottom: '16px', marginTop: 0 }}>
            {adjustments}
          </pre>
          <pre style={{ marginBottom: '16px', marginTop: 0 }}>
            ----------------------------
          </pre>
          <pre style={{ marginBottom: '16px', marginTop: 0 }}>{coldSoak}</pre>
        </div>
      </Grid2>
    </Modal>
  );
};
